export default function Cartridge_039() {
  const detailSetStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "32px",
  };

  const detailImageWrapStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  };

  const detailSetImageStyle = {
    flex: "0 0 42%",
  };

  const detailSetTextStyle = {
    flex: "1 1 0",
  };

  const detailImageStyle = {
    display: "block",
    maxWidth: "100%",
    height: "auto",
  };

  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "center", width: "100%" }}
      >
        <div style={{ width: "100%", maxWidth: "1200px" }}>
          <div className="prd_detail prd_editor">
            <div className="detail_point">
          <div className="detail-top">
            <div className="point-new-con">
              <div className="ndetail_img" style={detailImageWrapStyle}>
                <img
                  src="https://image.kr.canon/re/product/2017041414085301_14895881.jpg"
                  style={detailImageStyle}
                  alt="Cartridge 039 제품 사진"
                />
              </div>
            </div>
          </div>
          <div className="detail-main">
            <div className="detail-item">
              <div className="point-new-con">
                <p className="ndetail_tit2">정품 토너 사용은 필수</p>
                <p className="ndetail_txt">
                  캐논은 20여 년에 걸쳐 끊임없는 기술 혁신을 추진하여 카트리지
                  기술분야에서 총 1,000여건에 이르는 특허를 취득하였습니다. 또한
                  캐논 카트리지 사용시 편리성을 우선시하여 제품의 성능을 최대한
                  발휘하도록 설계 되었습니다. 나아가 엄격한 품질관리를 기반으로
                  고객에게 안심, 신뢰, 고품질을 제공하고 있습니다. 제품의 성능을
                  최적으로 유지하고, 안정된 품질, 쾌적한 출력 환경을 얻기 위하여
                  캐논 제품에는 캐논의 정품 카트리지 사용을 권장합니다. 만약
                  위조품을 사용하신다면 인쇄 품질의 저하 등, 기계 본체 본래의
                  성능이 충분히 발휘되지 않는 경우가 있기 때문에 주의해
                  주십시요. 위조품이 원인이라 생각되는 인쇄불량과 토너가루 누수
                  등의 사례도 보고되고 있습니다. 더불어 위조품을 포함한 비정품
                  토너카트리지 사용으로 인한 불량은 무상보증 서비스를 받으실 수
                  없습니다.{" "}
                </p>
                <div className="ndetail_img" style={detailImageWrapStyle}>
                  <img
                    src="https://image.kr.canon/re/product/2021110222023901_33171138.jpg"
                    style={detailImageStyle}
                    alt="정품마크와 위조방지라벨 사진"
                  />
                </div>
              </div>
            </div>
            <div className="detail-item">
              <div className="point-new-con">
                <p className="ndetail_tit2">
                  RoHS 규정의 특정 유해물질 제한사용
                </p>
                <p className="ndetail_txt">
                  소모품은 RoHS 규정 대상이 아니지만 캐논은 모든 순정 토너
                  카트리지에 RoHS 규정에 제한되어 있는 특정 유해 물질을 사용하지
                  않습니다. <br />
                  그렇기 때문에 인쇄물에 대해서도 안심하셔도 좋습니다. 또한,
                  모든 토너 카트리지 구성 부품에 대해서도 RoHS 규정을 준수하고
                  있습니다. (재자원화 부품 일부 제외) <br />
                  RoHS : 전기 · 전자 제품 및 자동차를 대상으로 납, 수은, 카드뮴,
                  6가크롬, PBB (폴리 브롬화 비페닐), PBDE(폴리 브롬화
                  디페닐에테르)등 6가지 유해물질을 사용하지 못하도록 하는
                  유럽연합(EU)의 환경규제{" "}
                </p>
                <div className="ndetail_img" style={detailImageWrapStyle}>
                  <img
                    src="https://image.kr.canon/re/product/2016090217142201_10492482.jpg"
                    style={detailImageStyle}
                    alt="RoHS 규정의 특정 유해물질 제한 사용관련 설명 사진"
                  />
                </div>
              </div>
            </div>
            <div className="detail-item">
              <div className="point-new-con">
                <div className="ndetail_set" style={detailSetStyle}>
                  <div
                    className="ndetail_img"
                    style={{ ...detailImageWrapStyle, ...detailSetImageStyle }}
                  >
                    <img
                      src="https://image.kr.canon/re/product/2016090217143901_10465455.jpg"
                      style={detailImageStyle}
                      alt="3중 체크에 의한 그린조달 실시 설명 사진"
                    />
                  </div>
                  <div className="ndetail_txt_set" style={detailSetTextStyle}>
                    <p className="ndetail_tit2">
                      3중 체크에 의한 그린조달 실시
                    </p>
                    <p className="ndetail_txt">
                      고객이 제품을 안심하고 사용하도록, 캐논은 제품에 사용되는
                      모든 부품, 재료에 함유된 특정화학 물질을 관리하고, 안전을
                      보증하는 제품화학물질 보증체제를 실시하고 있습니다. <br />
                      화학물질 데이터 · 부품및 재료에 함유되는 특정화학 물질의
                      데이터를 조달처로부터 입수하여 평가하고 있습니다. <br />
                      조달처 조사 · 부품 및 재재는 조달처의 환경심사
                      (환경매니지먼트와 법규제준수 등)를 실시해 기준을 충족한
                      회사로부터 조달하고 있습니다. 화학물질의 분석 · 주요 부품
                      및 재료에 함유되는 특정 화학물질을 캐논에서 분석, 평가하고
                      있습니다. <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail-item">
              <div className="point-new-con">
                <div className="ndetail_set" style={detailSetStyle}>
                  <div
                    className="ndetail_img"
                    style={{ ...detailImageWrapStyle, ...detailSetImageStyle }}
                  >
                    <img
                      src="https://image.kr.canon/re/product/2016090217145401_10552542.jpg"
                      style={detailImageStyle}
                      alt="100%재자원화 관련 설명 사진"
                    />
                  </div>
                  <div className="ndetail_txt_set" style={detailSetTextStyle}>
                    <p className="ndetail_tit2">100% 재자원화</p>
                    <p className="ndetail_txt">
                      “캐논은 회수한 정품 토너 카트리지를 매립하여 폐기하지
                      않고, 100% 재자원화합니다.” 1982년 캐논은 세계 최초로
                      ‘카트리지 교환 방식’에 의한 복사기를 발매하였습니다. 이
                      카트리지 방식은 손쉬운 유지보수, 소형화, 고품질의 획기적인
                      장점으로 인해 세계적으로 호평받고 있습니다. 토너
                      카트리지가 비약적으로 보급된 반면, 지구환경의 공생(共生)을
                      생각하는 캐논은 자원의 유효한 활용 이라는 문제의식을 갖고
                      있었습니다. 제조자로써의 기업책임을 다하고 있는 캐논은
                      1990년 업계 선두로 토너 카트리지의 리사이클 프로그램을
                      시작하여, 환경보호에 앞장서고 있습니다. <br />
                    </p>
                  </div>
                </div>
              </div>
              <img
                src="https://image.kr.canon/pds/editor/upload/product/office_product/HB/HB20-18-0252_toner.jpg"
                title=""
                alt=""
                style={{
                  verticalAlign: "baseline",
                  border: "0px solid rgb(0, 0, 0)",
                }}
              />
            </div>
          </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
